let snapshot = null;
const listeners = new Set();

export function setStatusSnapshot(value) {
  snapshot = value ? { ...value } : null;
  listeners.forEach((listener) => {
    try {
      listener(snapshot);
    } catch (error) {
      console.error("Status snapshot listener failed", error);
    }
  });
}

export function getStatusSnapshot() {
  return snapshot;
}

export function subscribeStatusSnapshot(listener) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
